<button type="button" class="no-button select-box" (click)="showOptions($event)" [ngClass]="{active : isActivated}">
    {{selectedValue}}
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
        <path d="M480-360 280-560h400L480-360Z" />
    </svg>
</button>
<div class="optionCalss" [hidden]="!isActivated">
    <button type="button" class="no-button" *ngFor="let codes of options" (click)="selected($event, codes)">
        {{ codes }}
    </button>
</div>